import { render, staticRenderFns } from "./Recruit.vue?vue&type=template&id=df884036&scoped=true"
import script from "./Recruit.vue?vue&type=script&lang=js"
export * from "./Recruit.vue?vue&type=script&lang=js"
import style0 from "./Recruit.vue?vue&type=style&index=0&id=df884036&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "df884036",
  null
  
)

export default component.exports